import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Chip,
    Skeleton,
} from '@mui/material';
import { getPublicUpdates, getCompanyInfo } from '../../api/api';

const Updates = () => {
    const [updates, setUpdates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        fetchUpdates();
        fetchCompanyInfo();
    }, []);

    const fetchCompanyInfo = async () => {
        try {
            const response = await getCompanyInfo();
            if (response.status && response.company) {
                setCompanyName(response.company.name);
            }
        } catch (error) {
            console.error('Error fetching company info:', error);
        }
    };

    const fetchUpdates = async () => {
        try {
            setLoading(true);
            const response = await getPublicUpdates();
            if (response.status) {
                setUpdates(response.updates);
            }
        } catch (error) {
            console.error('Error fetching updates:', error);
        } finally {
            setLoading(false);
        }
    };

    const getTypeColor = (type) => {
        switch (type) {
            case 'urgent_fix':
                return 'error';
            case 'major_update':
                return 'primary';
            default:
                return 'default';
        }
    };

    const getTypeLabel = (type) => {
        switch (type) {
            case 'urgent_fix':
                return 'Urgent Fix';
            case 'major_update':
                return 'Major Update';
            default:
                return 'Regular Update';
        }
    };

    // Skeleton loader component
    const SkeletonCard = () => (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                    <Skeleton variant="text" width="60%" height={32} />
                    <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={20} />
                <Skeleton variant="text" width="80%" height={20} />
            </CardContent>
        </Card>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Updates
                </Typography>
               {/* {companyName && (
               //     <Typography variant="body2" color="text.secondary">
               //         {companyName}
               //     </Typography>
               )}*/}
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Stay informed about the latest improvements and fixes to easyKNOW
                </Typography>
            </Box>

            {loading ? (
                <Box>
                    {Array.from({ length: 3 }).map((_, index) => (
                        <SkeletonCard key={index} />
                    ))}
                </Box>
            ) : updates.length === 0 ? (
                <Card>
                    <CardContent>
                        <Typography variant="body1" color="text.secondary" align="center" sx={{ py: 3 }}>
                            No updates available at this time.
                        </Typography>
                    </CardContent>
                </Card>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {updates.map((update) => (
                        <Card key={update.id} elevation={2}>
                            <CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                                    <Typography variant="h6" component="h2">
                                        {update.title}
                                    </Typography>
                                    <Chip
                                        label={getTypeLabel(update.type)}
                                        color={getTypeColor(update.type)}
                                        size="small"
                                    />
                                </Box>
                                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                                    {new Date(update.update_date).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    {update.description}
                                </Typography>
                                {update.details && (
                                    <Typography variant="body2" color="text.secondary">
                                        {update.details}
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default Updates;

